import React from 'react';
import styled, { css } from 'styled-components';
import { CommonFooterLayout } from 'src/payments/layout/common/footer';

type LoginContentContainerProps = {
  children: JSX.Element | JSX.Element[];
};

export function LoginContentContainer({ children }: LoginContentContainerProps): JSX.Element {
  return (
    <Container>
      <Content>{children}</Content>
      <CommonFooterLayout />
    </Container>
  );
}

const Container = styled.div`
  max-width: 375px;
`;

const Content = styled.div`
  ${({ theme: { colors } }) => css`
    border: 1px solid ${colors.grey[90]};
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 20px;
  `}
`;
